import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import { TourStatisticsDto } from '@/features/dashboard/tours/types/TourStatisticsDto.ts';

const useGetTourStatistics = (tourId: string) => {
  return useQuery(getTourStatisticsQueryOptions(tourId));
};

export const getTourStatisticsQueryOptions = (
  tourId: string,
): UseQueryOptions<TourStatisticsDto> => ({
  queryKey: toursApiQueryKeys.tourStatistics(tourId),
  queryFn: () => toursApi.getTourStatistics(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60,
});

export default useGetTourStatistics;
